import React from "react";

export const Paragraph = ({ children }) => (
  <section className="post-content">{children}</section>
);
